export enum WebSiteType {
  ADMIN = 'ADMIN',
  CONSUMER = 'CONSUMER'
}
